import {
  CAR_ABOUT_STEP,
  CAR_FIND_STEP,
  CAR_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Car";
import {
  CarOwner,
  DamageCountRecentYears,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Car/ProductDetails/FormElements/interfaces";

import { RENTAL_TYPE_VARIABLE } from "Store/interfaces/products/checkout/riskProducts/vehicleProducts/BaseCarProduct";
import { FormState } from "Store/priceCalculation/priceCalculationInterfaces";
import { booleanToFormBoolean } from "Utils/formUtils";
import { isDefined } from "Utils/functions";
import { DEDUCTIBLE_FOUR_THOUSAND } from "Utils/priceUtils";
import { getAgeFromDate } from "Validation/dateValidaton";
import { DEFAULT_DEDUCTIBLE_CAR } from "../carConstants";

export function mapFromCommerceCar(data: any): FormState {
  const otherOwnerAge = !data.insuranceHolderIsOwner
    ? getAgeFromDate(new Date(data.owner.dateOfBirth))
    : undefined;

  const deductibleCode = String(data.priceSpecifications.deductible.code);

  return {
    [CAR_FIND_STEP.id]: {
      brand: data.brand,
      model: data.model,
      year: data.modelYear,
      modelTypeName: data.type,
      modelType: data.configurationId,
      kw: data.kw,
      volume: data.volume,
      licensePlateNumber: isDefined(data.licensePlateNumber)
        ? data.licensePlateNumber
        : undefined,
      licensePlateNumberSearch: isDefined(data.licensePlateNumber)
        ? data.licensePlateNumber
        : undefined,
      tfaCode: data.tfaCode ?? data.trafikkforsikringsavgift?.code,
      warrantyType: data.warrantyType,

      // setting object finder
      licensePlateNumberSelected: isDefined(data.licensePlateNumber)
        ? data.licensePlateNumber
        : undefined,

      configurationId: data.configurationId,
      canBeBoughtOnline: data.canBeBoughtOnline ?? true,
    },
    [CAR_ABOUT_STEP.id]: {
      bonusPreOwnership: data.bonusPreOwnership,
      bonus: data.bonusLevelCode,
      mortgagee: booleanToFormBoolean(data.mortgagee),
      injuries:
        data.damageCountRecentYears === 0
          ? DamageCountRecentYears.NONE
          : DamageCountRecentYears.ONE,
      injuryYear:
        data.damageCountRecentYears !== 0
          ? String(data.yearOfLastDamage)
          : undefined,
      automaticallyPopulated: false,
    },
    [CAR_PRICE_STEP.id]: {
      carOwner: data.insuranceHolderIsOwner
        ? CarOwner.MYSELF
        : data.owner.relation,
      carOwnerAge: otherOwnerAge,
      deductible:
        deductibleCode === DEDUCTIBLE_FOUR_THOUSAND
          ? DEFAULT_DEDUCTIBLE_CAR
          : deductibleCode,
      yearlyKmNeed: String(data.yearlyKmNeed),
      usedByYoungerDriver: booleanToFormBoolean(data.usedByYoungerDriver),
      isCarTrimmed: isDefined(data.isCarTrimmed)
        ? booleanToFormBoolean(data.isCarTrimmed)
        : undefined,
      rentalType: data.rentalType ?? RENTAL_TYPE_VARIABLE.NONE,
      coverage: data.coverageGroup,
    },
  };
}
